import React from 'react';
import { styled } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const rotation = {
  up: 90,
  down: 270,
  left: 0,
  right: 180
};
const SvgChevron = props => /*#__PURE__*/_jsx(Svg, {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M15.9 20.8c.1.1.3.2.5.2s.3-.1.5-.2c.3-.2.3-.7 0-.9L8.6 12l8.2-7.9c.3-.2.3-.7 0-.9s-.7-.2-.9 0l-8.7 8.4c-.3.2-.3.7 0 .9l8.7 8.3z"
  })
});
const Svg = styled.svg.withConfig({
  displayName: "Chevron__Svg",
  componentId: "sc-z7xzx4-0"
})(["transform:rotate(", "deg);"], ({
  orientation = 'left'
}) => rotation[orientation]);
export default SvgChevron;